<template>
	<div>
		<div class="data6">
			<div class="data6Left" :style="{
				paddingLeft:bj+'px'
			}">
				<div class="data6LeftTil">
					{{list.data.menuTitle}}
				</div>
				<div class="data6LeftBox">
					<div class="data6LeftFor" v-for="(item,index) in list.data.content" :key="index">
						<div class="data6LeftForImg">
							<img :src="item.cover" />
						</div>
						<div class="data6LeftForName">
							{{item.title}}
						</div>
						<div class="data6LeftForCen">
							<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="data6Right">
				<!-- <img src="@/assets/product/page2/czjyZlys.png" /> -->
				<div class="swiper-data2-banner" :class="`swiper-data2-banner${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in list.data.videos" :key="index">
							<!-- <video :src="item" :autoplay="true" muted loop :style="{
								height:list.data.height+'px'
							}"></video> -->
							<template v-if="headerShow">
								<video :src="item" :autoplay="true" muted loop :style="{
								height:list.data.height+'px'
							}" webkit-playsinline playsinline x5-video-player-type="h5-page"></video>
							</template>
							<template v-else>
								<video :src="item" muted loop :style="{
								height:list.data.height+'px'
							}" webkit-playsinline playsinline x5-video-player-type="h5-page" x5-playsinline="true" controls preload="auto" :poster="item+'?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
							</template>
						</div>
					</div>
					<template v-if="!headerShow">
						<div class="swiper-hexin-prev"  :style="{
							left:`30px`,
							display:qhShow?activeIndex==0?'none':'block':'none'
						}" @click="prev()">
							<img src="@/assets/index/hxz.png" />
						</div>
						<div class="swiper-hexin-next" :style="{
							right:`30px`,
							display:qhShow?activeIndex==list.data.videos.length-1?'none':'block':'none'
						}" @click="next()">
							<img src="@/assets/index/hxy.png" />
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				byzlList: [{
						img: require('@/assets/product/page7/jgcs.png'),
						name: '激光传输',
						cen: '- 高速率激光传输可呈现更多细节信息，使图像更细腻- 进一步增强绝缘强度，提高抗干扰性和稳定性'
					},
					{
						img: require('@/assets/product/page7/wxgd.png'),
						name: '无线供电',
						cen: '- 实现无接触式供电，避免漏电风险- 免受高频电刀或周边设备干扰，为安全诊疗保驾护航'
					},
				],
				bj: '',
				qhShow:true,
				activeIndex: 0,
			}
		},
		mounted() {
			let t = this
			let name = '.swiper-data2-banner' + this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				// slidesPerView: 1,
				allowTouchMove: this.list.data.videos.length > 1 ? true : false,
				navigation: {
					prevEl: ".swiper-hexin-prev",
					nextEl: ".swiper-hexin-next",
				},
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},

				},
			});
			this.getWidth();
			this.$nextTick(function(){
				if(this.list.data.videos.length<2){
					this.qhShow=false
				}
			})
		},
		methods: {
			getWidth() {
				console.log(document.body.clientWidth, window.screen.availWidth)
				let width = ''
				if (document.body.clientWidth > 1200) {
					width = document.body.clientWidth - 1200;
				} else {
					width = 0;
				}
				this.$nextTick(function() {
					this.bj = width / 2
				})
			},
			next(){
				console.log("right")
				let t=this;
				if(t.activeIndex==t.list.data.videos.length-1){
					t.activeIndex = 0;
				}else{
					t.activeIndex++;
				}
				// this.mySwiper.slideNext()
			},
			prev(){
				let t=this;
				if(t.activeIndex==0){
					t.activeIndex = t.list.data.videos.length-1;
				}else{
					t.activeIndex--;
				}
				console.log("left")
				// this.mySwiper.slidePrev()
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data6 {
		display: flex;
		padding-bottom: 150px;

		.data6Left {
			flex: 1;
			padding-left: 250px;

			.data6LeftTil {
				font-size: 45px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				color: #000000;
				margin-bottom: 70px;
			}

			.data6LeftBox {
				display: flex;
				flex-wrap: wrap;
				width: 100%;

				.data6LeftFor {
					width: calc(49% - 40px);
					padding: 0 20px;
					margin-bottom: 70px;

					.data6LeftForImg {
						margin-bottom: 30px;

						img {
							width: 70px;
							height: 70px;
						}
					}

					.data6LeftForName {
						margin-bottom: 20px;
						font-size: 26px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #000000;
					}

					.data6LeftForCen {
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 300;
						color: #000000;
						white-space: pre-line;
					}
				}
			}
		}

		.data6Right {
			flex: 1;

			img {
				width: 100%;
				height: 600px;
				object-fit: cover;
			}

			video {
				width: 100%;
				height: 600px;
				object-fit: contain;
			}
		}
	}

	.swiper-data2-banner {
		overflow: hidden;

		// background: #000000;
		.swiper-slide {
			width: 100% !important;

		}
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
	}

	@media screen and (max-width:1200px) {
		.data6 {
			padding: 0 30px 30px !important;
			flex-wrap: wrap;

			.data6Left {
				padding-left: 0px !important;
				min-width: 100% !important;

				.data6LeftTil {
					font-size: 24px !important;
					margin-bottom: 20px !important;
				}

				.data6LeftBox {
					.data6LeftFor {
						margin-bottom: 20px !important;

						.data6LeftForImg {
							margin-bottom: 20px !important;

							img {
								width: 35px !important;
								height: 35px !important;
							}
						}

						.data6LeftForName {
							font-size: 18px !important;
						}

						.data6LeftForCen {
							font-size: 14px !important;
						}
					}
				}
			}

			.data6Right {
				min-width: 100% !important;

				img {
					height: auto !important;
					object-fit: contain !important;
				}

				video {
					width: 100%;
					height: auto !important;
					object-fit: contain;
				}
			}
		}
		.swiper-data2-banner{
			.swiper-hexin-prev{
				display: block;
			}
			.swiper-hexin-next{
				display: block;
			}
			.swiper-hexin-prev {
				position: absolute;
				top: 50%;
				left: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 100%;
				transform: translateY(-50%);
				transition: all 0.3s ease;
			}
			
			.swiper-hexin-next {
				transform: translateY(-50%);
				position: absolute;
				top: 50%;
				right: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.3s ease;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			}
		}
	}
</style>